<template>
  <div class="home">
		<h1>Historial</h1>
    <b-table striped hover :items="items" :fields="fields" v-on:row-clicked="showTravel"></b-table>
    <b-modal id="bv-modal" title="Viaje" @hidden="cancel" hide-footer>
    	<div v-if="action === ''">
        <br>
        <!--
        <b-button block size="lg" variant="outline-primary" @click="setAction('ticket')">
          Asignar Boleto Físico
        </b-button>
        <br>
        <br>
        -->
        <b-button block size="lg" variant="outline-primary" @click="goTicket()">
          Editar Boleto
        </b-button>
      	<b-button block size="lg" variant="outline-primary" @click="setAction('cancel')">
          Cancelar Boleto
        </b-button>
        <br>
      </div>
    	<div v-if="action === 'ticket'">
	      <p class="my-4">Ingrese folio de boleto</p>
	      <b-form-input v-model="ticketId" type="number" placeholder="Ingrese folio de boleto"></b-form-input>
	      <br/>
	      <b-button block size="lg" variant="outline-primary" @click="assignTicket()">
	        Asignar Folio
	      </b-button>
        <b-button block size="lg" variant="danger" @click="cancel()">
          Cancelar
        </b-button>
      </div>
      <div v-if="action === 'cancel'">
	      <p class="my-4">¿Desea cancelar este viaje de retorno? Se dará de baja el registro para ir a recolectar al cliente.</p>

	      <b-button block size="lg" variant="outline-primary" @click="cancelTicket()">
	        Si
	      </b-button>
        <b-button block size="lg" variant="danger" @click="cancel()">
          No
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import Parse from 'parse'
Vue.use(Parse)
Parse.initialize("bBzZ7wYYGIpQkPPB");
Parse.serverURL = 'https://aircab.herokuapp.com/parse'
// Parse.initialize("BewIZ9dlh4gNBStm")
// Parse.serverURL = 'https://aircabdev.herokuapp.com/parse'
var moment = require('moment-timezone')
var timezone = 'America/Mexico_City'

export default {
  name: 'history',
  data() {
    return {
    	fields: [
        {
          key: 'queueId',
          label: 'Id',
          sortable: true,
          // Variant applies to the whole column, including the header and footer
          // variant: 'danger'
        },
        {
          key: 'createdAt',
          label: 'Fecha de Venta',
          sortable: true,
          // Variant applies to the whole column, including the header and footer
          // variant: 'danger'
        },
        {
          key: 'name',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'phone',
          label: 'Teléfono',
          sortable: true
        },
        {
          key: 'origin',
          label: 'Origen',
          sortable: false
        },
        {
          key: 'destination',
          label: 'Destino',
        },
        {
          key: 'scheduledAt',
          label: 'Fecha de Reserva',
          sortable: true,
          // Variant applies to the whole column, including the header and footer
          // variant: 'danger'
        },
        {
          key: 'status',
          label: 'Estatus',
        },
        {
          key: 'zoneName',
          label: 'Zona',
        },
        {
          key: 'price',
          label: 'Precio',
        },
        {
          key: 'note',
          label: 'Nota',
        },
      ],
			items: [
      ],
      action: '',
      ticketId: null,
      currentObj: null,
      currentUser: null,
      currentSession: null
    }
  },
  async created() {
   
  },
  async mounted() {
    this.currentUser = Parse.User.current()
    this.currentSession = await Parse.Session.current()
    console.log('currentUser',this.currentUser, this.currentUser._getId(), this.currentSession)
   	this.load()
  },
  methods: {
    goTicket: function() {
      console.log('goTicket', this.currentObj)
	    this.$router.replace('/edit/' +  this.currentObj.queueId)
    },
  	load: async function () {
  		let vue = this
      let currentUser = Parse.User.current()
      const queues = await Parse.Cloud.run('getTravelsBySellerCallCenter', {
        userId: currentUser.id
      })
			vue.items = []
			let data = queues.map(function (queue) {
	      console.log('virtual', { name: queue.get('clientFirstName') + ' ' + queue.get('clientLastName'), origin: queue.get('originName'), destination: queue.get('destinyName'), createdAt: queue.get('createdAt'), folio: queue.get('folio') })
	      vue.items.push({
          queueId: queue.id,
	      	queue: queue,
	      	name: queue.get('clientFirstName') + ' ' + queue.get('clientLastName'),
	      	phone: queue.get('clientPhone'),
	      	note: queue.get('note'),
	      	origin: queue.get('originName'),
	      	destination: queue.get('destinyName'),
	      	folio: queue.get('folio'),
	      	price: queue.get('estimatedCost'),
	      	zoneName: queue.get('zonePrice')? queue.get('zonePrice').get('zone').get('name') : '',
	      	status: queue.get('status') === 0 ? 'Abierto' : queue.get('status') === 2 ? 'Cancelado' : 'Asignado',
	      	createdAt: moment.tz(queue.get('createdAt'), timezone).format('YYYY-MM-DD HH:mm:ss'),
	      	scheduledAt: moment.tz(queue.get('scheludedAt'), timezone).format('YYYY-MM-DD HH:mm:ss')
	      })
	    })
			console.log('queues', queues)
  	},
  	showTravel: function (obj) {
  		console.log('obj', obj)
  		this.currentObj = obj
      this.$bvModal.show('bv-modal')
      this.ticketId = ''
    },
  	setAction: function (action) {
  		this.action = action
  	},
  	assignTicket: async function () {
      console.log('assingTicket', this.ticketId)
      if (this.ticketId.length !== 15) {
        alert('Se necesitan ingresar los 15 dígitos del código del boleto')
      } else {
        this.currentObj.queue.set('folio', this.ticketId)
        await this.currentObj.queue.save()
        this.$bvModal.hide('bv-modal')
        this.cancel()
        this.load()
        alert('Boleto Asignado')
      }
  	},
  	cancelTicket: async function () {
      console.log('assingTicket', this.ticketId)
      const result = await Parse.Cloud.run('cancelTravelCallCenter', {
        travelId: this.currentObj.queue.id
      })
  		// this.currentObj.queue.set('status', 3)
  		// await this.currentObj.queue.save()
      this.$bvModal.hide('bv-modal')
      this.cancel()
      this.load()
      alert('Boleto Cancelado')
  	},
  	cancel: function () {
  		console.log('cancel')
  		this.action = ''
      this.$bvModal.hide('bv-modal')
  	}
  }
}
</script>
